<template>
  <div :class="cssClass">
    <v-container grid-list-md fluid class="database-container">
      <v-layout row wrap class="main_layout_db">
        <v-flex d-flex xs12 md6 lg4>
          <v-layout row wrap v-if="dbIndex.length > 0">
            <v-flex sm12 class="db-list">
              <v-layout row wrap>

                <v-flex xs12 class="search">
                  <v-card tile flat>
                    <div class="col-inner col-highlight">
                      <v-form @submit.prevent="search">
                        <v-layout row wrap>
                          <v-flex sm9>
                            <v-text-field :label="translate['Suche'][lang]" id="search_term" color="secondary"
                              :value="searchTerm" @change="v => searchTerm = v"></v-text-field>
                          </v-flex>
                          <v-flex sm3 class="search_btn_col">
                            <v-btn flat color="mari" class="search_btn" @click="search">
                              <v-icon>search</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex sm12 class="search__extended">
                            <v-checkbox dense v-model="searchFulltext" :label="translate['Volltextsuche'][lang]"
                              @change="search"></v-checkbox>
                            <v-checkbox dense v-model="searchArtists" :label="translate['Künstler'][lang]"
                              @change="search"></v-checkbox>
                            <v-checkbox dense v-model="searchWorks" :label="translate['Werke'][lang]"
                              @change="search"></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-form>
                      <template v-if="searchResults !== null">
                        <h4 class="search_results_title">{{ translate['search_results'][lang] }}</h4>
                        <div v-text="searchResults.length + ' ' + translate['num_search_results'][lang]" class="s__cat">
                        </div>
                        <v-list>
                          <div v-for="(searchResult, index) in searchResults" :key="searchResult.id">
                            <v-list-tile ripple :id="'searchResult' + searchResult.id"
                              @click="selectSharedObject(searchResult.id)">
                              <v-list-tile-content>
                                <v-list-tile-title v-if="searchResult.creator" class="list_small_item">
                                  {{ searchResult.creator }}
                                </v-list-tile-title>
                                <v-list-tile-title>{{ searchResult.title }}</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-divider v-if="index + 1 < searchResults.length" :key="index"></v-divider>
                          </div>
                        </v-list>
                      </template>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 class="filter">
                  <div class="col-inner col-highlight">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-select color="mari" :items="filterItems" v-model="filterElement" single-line
                          :hint="translate['Anzeigen alle Objekte'][lang]"
                          :label="translate['Anzeigen alle Objekte'][lang]" id="filter_select1"></v-select>
                      </v-flex>
                      <v-flex xs6>
                        <v-select color="mari" :items="filter2Items" v-model="filter2Element" single-line
                          :hint="translate['Nachgewiesen in'][lang]"
                          :label="translate['Nachgewiesen in'][lang]"></v-select>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-tabs class="gws_tabs">
                    <v-tab>
                      <v-card>
                        <v-card-title>
                          <h3>{{ translate['Künstler'][lang] }}</h3>
                        </v-card-title>
                      </v-card>
                    </v-tab>
                    <v-tab>
                      <v-card>
                        <v-card-title>
                          <h3>{{ translate['Kunstwerke'][lang] }}</h3>
                        </v-card-title>
                      </v-card>
                    </v-tab>
                    <v-tab>
                      <v-card>
                        <v-card-title>
                          <h3>{{ translate['Bibliotheksobjekte'][lang] }}</h3>
                        </v-card-title>
                      </v-card>
                    </v-tab>
                    <v-tabs-items>
                      <v-tab-item>
                        <!-- <pre>{{ listInfo }}</pre> -->
                        <!-- <pre>{{ listInfoSortedNames }}</pre> -->
                        <!-- <pre>{{ listInfoCreators }}</pre> -->
                        <v-expansion-panel expand v-for="(sortedName, idx) in listInfoSortedNames"
                          :key="'list_info_sorted_names_' + idx">
                          <v-expansion-panel-content>
                            <div slot="header">
                              <h4>{{ sortedName }}</h4>
                            </div>
                            <v-list>
                              <div v-for="(work, work_idx) in listInfoCreators[sortedName]['titles']"
                                :key="'list_info_sorted_names_titles_' + idx + '_title_' + work_idx">
                                <v-list-tile ripple v-on:click="selectSharedObject(work.id)" :id="'aso' + work.id">
                                  <v-list-tile-content>
                                    <v-list-tile-title class="artist_list_work_title">
                                      {{ work.title }}
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                              </div>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-tab-item>
                      <v-tab-item>
                        <v-expansion-panel v-model="expansionPanelAllWorks" expand>
                          <v-expansion-panel-content>
                            <div slot="header">
                              <h4>{{ translate['Alle Werke'][lang] }}</h4>
                            </div>
                            <v-list>
                              <div v-for="(listInfoTitle, idx) in listInfoTitles"
                                :key="'list_info_titles_' + listInfoTitle.id" class="gws_list_tiles_with_sub_title">
                                <v-list-tile ripple v-on:click="selectSharedObject(listInfoTitle.id)"
                                  :id="'oso' + listInfoTitle.id">
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      {{ listInfoTitle.title }}
                                      <div v-if="listInfoTitle.creator" class="gws_tile_sub_title">
                                        {{ listInfoTitle.creator }}
                                      </div>
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                                <v-divider v-if="idx + 1 < listInfoTitles.length"></v-divider>
                              </div>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-tab-item>
                      <v-tab-item>
                        <v-expansion-panel expand v-for="(sortedName, idx) in listInfoSortedAuthors"
                          :key="'list_info_sorted_authors_' + idx">
                          <v-expansion-panel-content>
                            <div slot="header">
                              <h4>{{ (sortedName === 'ohne Autorenangabe') ? translate['ohne Autorenangabe'][lang] : sortedName }}</h4>
                              <!-- <h4>{{ sortedName }}</h4> -->
                            </div>
                            <v-list>
                              <div v-for="(work, work_idx) in listInfoAuthors[sortedName]['titles']"
                                :key="'list_info_sorted_authors_titles_' + idx + '_title_' + work_idx">
                                <v-list-tile ripple v-on:click="selectSharedObject(work.id)" :id="'aso' + work.id">
                                  <v-list-tile-content>
                                    <v-list-tile-title class="artist_list_work_title">
                                      {{ work.title }}
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                              </div>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex d-flex xs12 md6 lg8 child-flex v-if="error" id="error_object">
          <v-card flat class="trbg">
            <div class="main_o_list">
              <div class="selection_main error">
                <div class="s__error">
                  <p v-html="translate['404'][lang]"></p>
                  <p v-html="error"></p>
                </div>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex d-flex xs12 md6 lg8 child-flex xselected_object v-if="activeObjectId" id="xselected_object">
          <v-card v-if="sharedObjectLoader > 0" flat class="trbg shared-object-loader-container">
            <v-progress-circular indeterminate size="64" color="mari"></v-progress-circular>
          </v-card>
          <v-card v-else flat class="trbg nbg selected-object-card">
            <div id="selected_object" class="selected_object">
              <div v-if="sharedObject.hasImage">
                <v-carousel hide-delimiters :cycle="false" v-model="siCarousel"
                  :hide-controls="(sharedObject.imageCount === 1) ? true : false">
                  <v-carousel-item
                    v-for="(image, idx) in sharedObject.linked_objects.filter(e => e.subject_item_type === 'Bilddokument' && e.meta['Primärabbildung'] === 'ja' && typeof e.meta.filename !== 'undefined' && e.meta.filename !== '')"
                    :src="getImgPath(image)" :key="'img_prim_' + idx" v-on:click.native="openLightbox(image, $event)">
                    <div class="img_meta">
                      <a :href="'#relo_' + image.id" v-on:click="openPanel(image.id, $event)">
                        <v-icon medium color="primary" class="info-icon">info</v-icon>
                      </a>
                    </div>
                  </v-carousel-item>
                  <v-carousel-item
                    v-for="(image, idx) in sharedObject.linked_objects.filter(e => e.subject_item_type === 'Bilddokument' && (!e.meta['Primärabbildung'] || e.meta['Primärabbildung'] !== 'ja') && typeof e.meta.filename !== 'undefined' && e.meta.filename !== '')"
                    :src="getImgPath(image)" :key="'img_' + idx" v-on:click.native="openLightbox(image, $event)">
                    <div class="img_meta">
                      <a :href="'#relo_' + image.id" v-on:click="openPanel(image.id, $event)">
                        <v-icon medium color="primary" class="info-icon">info</v-icon>
                      </a>
                    </div>
                  </v-carousel-item>
                </v-carousel>
                <div v-if="imgCaption || imgCopyright" class="img-caption-and-copyright">
                  <div v-if="imgCaption" v-html="imgCaption" class="img-caption"></div>
                  <div v-if="imgCopyright" v-html="'&copy; ' + imgCopyright" class="img-copyright"></div>
                </div>
              </div>
              <div v-else class="no_img" v-text="translate['Keine Abbildung vorhanden'][lang]"></div>
            </div>
            <div class="main_o_list">
              <div class="selection_main">
                <div class="s__author" v-html="getCreator(sharedObject)"></div>
                <div class="s__title" v-html="getTitleWithDate(sharedObject)"></div>
                <div class="s__tech">
                  <span v-html="getMaterialAndTech(sharedObject)"></span><span
                    v-if="getMaterialAndTech(sharedObject) && sharedObject.cmsg_meta['Maße']">,</span>
                  <span v-html="sharedObject.cmsg_meta['Maße']"></span>
                </div>
                <div v-if="sharedObject.meta.Lost_Art_Permalink">
                  <a :href="sharedObject.meta.Lost_Art_Permalink" target="_blank" rel="noopener"
                    v-text="translate['lost_art_link'][lang]"></a>
                </div>
                <div v-if="sharedObject.meta.Forschungsstand && lang === 'de'" class="my-4">
                  <div class="s__cat">{{ translate['Forschungsstand'][lang] }}</div>
                  <div v-html="sharedObject.meta.Forschungsstand"></div>
                </div>
                <div v-if="sharedObject.meta.state_of_research && lang === 'en'" class="my-4">
                  <div class="s__cat">{{ translate['Forschungsstand'][lang] }}</div>
                  <div v-html="sharedObject.meta.state_of_research"></div>
                </div>
                <div v-if="sharedObject.meta['Basisrecherche_(Hausarbeit)_von']" class="my-4">
                  <div class="s__cat">{{ translate['Basisrecherche (Hausarbeit) von'][lang] }}</div>
                  <div v-html="sharedObject.meta['Basisrecherche_(Hausarbeit)_von']"></div>
                </div>
                <div v-if="sharedObject.meta['Danksagung___DE'] && lang === 'de'" class="mt-3">
                  <div class="s__cat">{{ translate['Danksagung'][lang] }}</div>
                  <div v-html="sharedObject.meta['Danksagung___DE']"></div>
                </div>
                <div v-if="sharedObject.meta['Danksagung___EN'] && lang === 'en'" class="mt-3">
                  <div class="s__cat">{{ translate['Danksagung'][lang] }}</div>
                  <div v-html="sharedObject.meta['Danksagung___EN']"></div>
                </div>
                <div class="citation-hint">
                  <div class="citation-hint__header">
                    {{ translate['Zitierhinweis'][lang] }}
                  </div>
                  <div class="citation-hint__body">
                    {{ translate['Forschungsdatenbank'][lang] }} {{ permLink }}
                  </div>
                </div>
                <!-- <pre>{{ siCarousel }}</pre> -->
                <!-- <pre>{{ sharedObject }}</pre> -->
                <!-- <pre>{{ metaSources }}</pre> -->
              </div>
            </div>
            <v-flex v-if="sharedObject && sharedObject.transactions.length > 0" d-flex xs12 child-flex
              class="transactions" id="transactions">
              <div class="transactions_list_wrapper">
                <h2 class="transactions_list_header">{{ translate['transactions'][lang] }}</h2>
                <template>
                  <v-data-table :headers="transactionHeaders" :items="sharedObject.transactions"
                    class="elevation-1 transaction_table" hide-actions>
                    <template slot="items" slot-scope="props">
                      <td
                        :class="{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }">
                        <span v-html="props.item['Datum Transaktion Ausgabe']" />
                      </td>
                      <td
                        :class="{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }">
                        <span v-html="props.item.Vorbesitzer" />
                      </td>
                      <td
                        :class="{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }">
                        <span v-html="props.item['Ort Vorbesitzer']" />
                      </td>
                      <td
                        :class="{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }">
                        <span v-html="props.item['Erwerber']" />
                      </td>
                      <td
                        :class="{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }">
                        <span v-html="props.item['Ort Erwerber']" />
                      </td>
                      <td
                        :class="{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }">
                        <span v-html="props.item['Transaktion Ausgabe']" />
                      </td>
                    </template>
                  </v-data-table>
                </template>
              </div>
            </v-flex>
            <v-expansion-panel class="metadata_from_sources" expand v-model="expansionPanelMetadataFromSources">
                <v-expansion-panel-content>
                  <div slot="header" class="fsi">{{ translate['mehr'][lang] }}</div>
                  <div class="dbox px_sm small">
                    <div
                      v-for="(linked_objects_num_field, linked_objects_num_field_name, idx_lofn) in sharedObject.linked_objects_num_fields"
                      :key="idx_lofn" class="mb-4">
                      <div class="s__cat">{{ translate[linked_objects_num_field_name][lang] }}</div>
                      <v-expansion-panel v-for="(field, idx_f) in linked_objects_num_field" :key="idx_f"
                        class="sub_expansion">
                        <v-expansion-panel-content>
                          <div slot="header">
                            {{ field['text'] }}
                            <span v-if="field['count'] > 1">({{ field['count'] }})</span>
                          </div>
                          <div v-for="(linked_object, idx_lo) in sharedObject.linked_objects" :key="idx_lo">
                            <a v-if="linked_object['meta'][linked_objects_num_field_name] && linked_object['meta'][linked_objects_num_field_name] === field['text']"
                              v-html="getMetadataLinkText(linked_object)" @click="openPanel(linked_object.id, $event)"
                              :href="'#relo_' + linked_object.id" class="linked display-block sm_lh_mb"></a>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            <v-flex d-flex xs12 child-flex class="linked_metas" id="linked_metas">
              <v-card flat class="trbg">
                <h2 class="linked_object_list_header header_top">{{ translate['beziehungen_zu_diesem_werk'][lang] }}</h2>
                <SourcesList v-if="sharedObject" :sharedObject="sharedObject" :translate="translate" :lang="lang"
                  :metaSources="metaSources"></SourcesList>
              </v-card>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <div v-if="lightboxImage !== null && lightboxImage.meta.filename" class="lightbox" @click="closeLightbox()">
      <img :src="getImgPath(lightboxImage)" :alt="getImageTitle(lightboxImage)">
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SourcesList from '@/components/pages/partials/SourcesList'
export default {
  name: 'DatabaseNew',
  components: {
    SourcesList
  },
  data () {
    return {
      // cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase() + ' database',
      cssClass: 'database',
      searchTerm: '',
      foo: '',
      searchFulltext: true,
      searchArtists: true,
      searchWorks: true,
      searchResults: null,
      filterElement: null,
      filter2Element: null,
      expansionPanelAllWorks: [true],
      activeObjectId: null,
      siCarousel: null,
      lightboxImage: null,
      expansionPanelMetadataFromSources: [true],
      transactionHeaders: [
        {
          align: 'left',
          sortable: false,
          text: 'Datum',
          value: 'Datum Transaktion Ausgabe',
          value_en: 'Date Transaction Issue',
          class: 'hidden'
        },
        {
          sortable: false,
          align: 'left',
          text: 'Vorbesitzer',
          value: 'Vorbesitzer',
          value_en: 'Previous Owner'
        },
        {
          sortable: false,
          align: 'left',
          text: 'Ort Vorbesitzer',
          value: 'Ort Vorbesitzer',
          value_en: 'Location Previous Owner'
        },
        {
          sortable: false,
          align: 'left',
          text: 'Erwerber/Besitzer ',
          value: 'Erwerber/Besitzer',
          value_en: 'Acquirer/Owner'
        },
        {
          sortable: false,
          align: 'left',
          text: 'Ort Erwerber',
          value: 'Ort Erwerber',
          value_en: 'Location Acquirer'
        },
        {
          sortable: false,
          align: 'left',
          text: 'Transaktion',
          value: 'Transaktion Ausgabe',
          value_en: 'Transaction Issue',
          class: 'wide_cell hidden'
        }
      ],
      error: null,
      noimg: 'noimg.svg'
    }
  },
  methods: {
    ...mapActions(['getDbIndex', 'fetchSharedObject']),
    search () {
      this.searchResults = null
      const searchResults = []
      if (this.searchTerm && this.searchTerm.length > 2) {
        const searchTerm = this.searchTerm.toLowerCase()
        const map = new Map()
        for (let i = 0; i < this.dbIndex.length; i++) {
          if (this.searchFulltext) {
            if (
              typeof this.dbIndex[i].meta !== 'undefined' && this.dbIndex[i].meta !== null &&
              typeof this.dbIndex[i].cmsg_meta !== 'undefined' && this.dbIndex[i].cmsg_meta !== null &&
              (
                (this.dbIndex[i].meta['Sigle'] &&
                  this.dbIndex[i].meta['Sigle'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].meta['Autor___Normansetzung'] &&
                  this.dbIndex[i].meta['Autor___Normansetzung'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].meta['Titel - Normansetzung'] &&
                  this.dbIndex[i].meta['Titel - Normansetzung'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].meta['Basisrecherche_(Hausarbeit)_von'] &&
                  this.dbIndex[i].meta['Basisrecherche_(Hausarbeit)_von'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].meta['Forschungsstand'] &&
                  this.dbIndex[i].meta['Forschungsstand'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].meta['state_of_research'] &&
                  this.dbIndex[i].meta['state_of_research'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Sigle'] &&
                  this.dbIndex[i].cmsg_meta['Sigle'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Titel'] &&
                  this.dbIndex[i].cmsg_meta['Titel'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Urheber'] &&
                  this.dbIndex[i].cmsg_meta['Urheber'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Material_und_Technik'] &&
                  this.dbIndex[i].cmsg_meta['Material_und_Technik'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Ma\u00dfe'] &&
                  this.dbIndex[i].cmsg_meta['Ma\u00dfe'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Rahmen'] &&
                  this.dbIndex[i].cmsg_meta['Rahmen'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Rahmen'] &&
                  this.dbIndex[i].cmsg_meta['Rahmen'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Rubrik'] &&
                  this.dbIndex[i].cmsg_meta['Rubrik'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Implizite_Orstangabe'] &&
                  this.dbIndex[i].cmsg_meta['Implizite_Orstangabe'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Chronologische_Kategorie'] &&
                  this.dbIndex[i].cmsg_meta['Chronologische_Kategorie'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Urheber___Normalformat'] &&
                  this.dbIndex[i].cmsg_meta['Urheber___Normalformat'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Urheber___Normalformat_Display'] &&
                  this.dbIndex[i].cmsg_meta['Urheber___Normalformat_Display'].toLowerCase().indexOf(searchTerm) > -1)
              )
            ) {
              searchResults.push(
                {
                  id: this.dbIndex[i].id,
                  title: this.getTitle(this.dbIndex[i]),
                  creator: this.getCreator(this.dbIndex[i]),
                  creator_sort: this.getSortByCreator(this.dbIndex[i])
                }
              )
            }
          } else {
            if (
              this.searchArtists &&
              !map.has(this.dbIndex[i].id) &&
              typeof this.dbIndex[i].meta !== 'undefined' && this.dbIndex[i].meta !== null &&
              typeof this.dbIndex[i].cmsg_meta !== 'undefined' && this.dbIndex[i].cmsg_meta !== null &&
              (
                (this.dbIndex[i].meta['Autor___Normansetzung'] &&
                  this.dbIndex[i].meta['Autor___Normansetzung'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Urheber'] &&
                  this.dbIndex[i].cmsg_meta['Urheber'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Urheber___Normalformat'] &&
                  this.dbIndex[i].cmsg_meta['Urheber___Normalformat'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Urheber___Normalformat_Display'] &&
                  this.dbIndex[i].cmsg_meta['Urheber___Normalformat_Display'].toLowerCase().indexOf(searchTerm) > -1)
              )
            ) {
              map.set(this.dbIndex[i].id, true)
              searchResults.push(
                {
                  id: this.dbIndex[i].id,
                  title: this.getTitle(this.dbIndex[i]),
                  creator: this.getCreator(this.dbIndex[i]),
                  creator_sort: this.getSortByCreator(this.dbIndex[i])
                }
              )
            }
            if (
              this.searchWorks &&
              !map.has(this.dbIndex[i].id) &&
              typeof this.dbIndex[i].meta !== 'undefined' && this.dbIndex[i].meta !== null &&
              typeof this.dbIndex[i].cmsg_meta !== 'undefined' && this.dbIndex[i].cmsg_meta !== null &&
              (
                (this.dbIndex[i].meta['Titel - Normansetzung'] &&
                  this.dbIndex[i].meta['Titel - Normansetzung'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Titel'] &&
                  this.dbIndex[i].cmsg_meta['Titel'].toLowerCase().indexOf(searchTerm) > -1) ||
                (this.dbIndex[i].cmsg_meta['Beschreibung'] &&
                  this.dbIndex[i].cmsg_meta['Beschreibung'].toLowerCase().indexOf(searchTerm) > -1)
              )
            ) {
              map.set(this.dbIndex[i].id, true)
              searchResults.push(
                {
                  id: this.dbIndex[i].id,
                  title: this.getTitle(this.dbIndex[i]),
                  creator: this.getCreator(this.dbIndex[i]),
                  creator_sort: this.getSortByCreator(this.dbIndex[i])
                }
              )
            }
          }
        }
        if (searchResults.length > 0) {
          searchResults.sort((a, b) => {
            if (a.creator_sort < b.creator_sort) {
              return -1
            }
            if (a.creator_sort > b.creator_sort) {
              return 1
            }
            if (a.creator_sort === b.creator_sort) {
              if (a.title < b.title) {
                return -1
              }
              if (a.title > b.title) {
                return 1
              }
            }
            return 0
          })
        }
        this.searchResults = searchResults
        // console.log(searchResults)
      }
    },
    getCreator (item) {
      if (item.meta['Autor___Normansetzung']) {
        return item.meta['Autor___Normansetzung']
      } else if (item.cmsg_meta['Urheber___Normalformat_Display']) {
        return item.cmsg_meta['Urheber___Normalformat_Display']
      } else if (item.cmsg_meta['Urheber']) {
        return item.cmsg_meta['Urheber']
      } else {
        return ''
      }
    },
    getSortByCreator (item) {
      if (item.meta['Autor___Normansetzung___Sortierung']) {
        return item.meta['Autor___Normansetzung___Sortierung']
      } else if (item.cmsg_meta['Urheber___Normalformat']) {
        return item.cmsg_meta['Urheber___Normalformat']
      } else {
        return this.getCreator(item)
      }
    },
    getTitle (item) {
      if (item.meta['Titel___Normansetzung']) {
        return item.meta['Titel___Normansetzung']
      } else if (item.cmsg_meta['Titel']) {
        return item.cmsg_meta['Titel']
      } else if (item.cmsg_meta['Beschreibung']) {
        return item.cmsg_meta['Beschreibung']
      } else {
        return ''
      }
    },
    getTitleWithDate (item) {
      const title = this.getTitle(item)
      if (item.meta['Datierung___Normansetzung']) {
        return title + ', ' + item.meta['Datierung___Normansetzung']
      } else if (item.cmsg_meta['Datierung']) {
        return title + ', ' + item.cmsg_meta['Datierung']
      } else {
        return title
      }
    },
    getMaterialAndTech (item) {
      if (item.meta['Material_und_Technik___Normansetzung']) {
        return item.meta['Material_und_Technik___Normansetzung']
      } else if (item.cmsg_meta['Material_und_Technik']) {
        return item.cmsg_meta['Material_und_Technik']
      } else {
        return ''
      }
    },
    getImageTitle (img) {
      if (img.meta['Bildlegende']) {
        return img.meta['Bildlegende']
      } else if (img.meta['Title']) {
        return img.meta['Title']
      } else if (img.meta['filename']) {
        return img.meta['filename']
      } else if (img['id']) {
        return img['id']
      } else {
        return ''
      }
    },
    selectSharedObject (id) {
      id = parseInt(id)
      let prescrollElement = document.getElementById('xselected_object')
      if (prescrollElement) {
        prescrollElement.scrollIntoView({ behavior: 'instant', block: 'start' })
      }
      this.siCarousel = null
      this.fetchSharedObject(id).then((result) => {
        this.activeObjectId = id
        if (this.$route.params.oid !== id) {
          this.$router.push({ name: 'Database', params: { oid: id } }).catch(() => { })
        }
        this.expansionPanelMetadataFromSources = [true]
        this.$nextTick(() => {
          let el = document.getElementById('selected_object')
          if (el) {
            setTimeout(() => {
              el.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }, 100)
          }
        })
      })
        .catch((error) => {
          this.error = error
        })
    },
    openPanel (id, event) {
      event.preventDefault()
      event.stopPropagation()
      let parent = document.getElementById('relo_' + id)
      if (parent) {
        let check = parent.firstChild.firstChild.classList.contains('v-expansion-panel__container--active')
        if (!check) {
          let el = document.getElementById('list_o_' + id)
          el.click()
        }
        let alle = document.getElementsByClassName('related_list')
        for (var i = 0; i < alle.length; i++) {
          alle[i].classList.remove('sm_bdmark_on')
        }
        parent.classList.add('sm_bdmark_on')
        setTimeout(() => {
          parent.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      }
    },
    getImgPath (img) {
      return img.meta.filename && img.meta.filename !== this.noimg
        ? 'https://www.mari-portal.de/omeka/files/fullsize/' + img.meta.filename
        : 'https://www.mari-portal.de/omeka/files/assets/' + this.noimg
    },
    openLightbox (img, event) {
      img.meta.filename = img.meta.filename
        ? img.meta.filename.toLowerCase()
        : this.noimg
      this.lightboxImage = img
    },
    closeLightbox (event) {
      this.lightboxImage = null
    },
    getMetadataLinkText (linkedObject) {
      if (linkedObject.meta['Quellenangabe']) {
        return linkedObject.meta['Quellenangabe']
      } else if (
        linkedObject.meta['Sigle Quelle ID'] &&
        this.metaSources[linkedObject.meta['Sigle Quelle ID']]['meta']['Ausgabe-Format']
      ) {
        return this.metaSources[linkedObject.meta['Sigle Quelle ID']]['meta']['Ausgabe-Format']
      } else if (
        linkedObject.meta['Sigle Quelle ID'] &&
        this.metaSources[linkedObject.meta['Sigle Quelle ID']]['meta']['Bezeichnung']
      ) {
        return this.metaSources[linkedObject.meta['Sigle Quelle ID']]['meta']['Bezeichnung']
      } else if (linkedObject.meta['Angabe Online-Quelle, Bezeichnung']) {
        return linkedObject.meta['Angabe Online-Quelle, Bezeichnung']
      } else if (linkedObject.meta['Title']) {
        return linkedObject.meta['Title']
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.getDbIndex()
      .then(() => {
        if (this.$route.params.oid) {
          this.selectSharedObject(this.$route.params.oid)
        }
      })
  },
  watch: {
    $route (to, from) {
      if (to.params.oid) {
        this.selectSharedObject(to.params.oid)
      }
    }
  },
  computed: {
    ...mapGetters([
      'translate',
      'lang',
      'dbIndex',
      'sharedObject',
      'sharedObjectLoader',
      'metaSources'
    ]),
    filterItems: function () {
      return [
        { text: this.translate['alle'][this.lang], value: 'all' },
        { text: this.translate['von MARI bearbeitet'][this.lang], value: 'edited' },
        { text: this.translate['von MARI lokalisiert'][this.lang], value: 'mariLocalized' },
        { text: this.translate['lokalisiert vor MARI'][this.lang], value: 'pre' }
        // { text: this.translate['nur Buchobjekte'][this.lang], value: 'booksonly' }
      ]
    },
    filter2Items: function () {
      return [
        { text: this.translate['alle Quellen'][this.lang], value: 'all' },
        { text: 'Lepke 1934', value: 'lepke' },
        { text: 'Union 1934', value: 'union' },
        { text: this.translate['andere Quellen'][this.lang], value: 'others' }
      ]
    },
    listInfo: function () {
      const infos = { titles: [], creators: {}, sortedNames: [], authors: {}, sortedAuthors: [] }
      const filter = this.filterElement || 'all'
      const filter2 = this.filter2Element || 'all'
      let statusEditing, statusResearch, statusSigle, creator, creatorSort, title, author

      this.dbIndex.forEach(item => {
        statusEditing = item.meta['Status_Bearbeitung'] || ''
        statusResearch = item.meta['Status_Recherche'] || ''
        statusSigle = item.meta['Sigle_konstituierende_Nachricht'] || ''
        if (
          (filter === 'all' ||
            (filter === 'edited' &&
              (statusEditing === 'Forschung begonnen' || statusEditing === 'vorläufig abgeschlossen')) ||
            (filter === 'pre' &&
              (statusEditing === 'Claim vor oder außerhalb von MARI')) ||
            (filter === 'mariLocalized' &&
              (statusResearch === 'lokalisiert'))
            //   ||
            // (filter === 'booksonly' &&
            //   item.meta.Bibliotheksobjekt && item.meta.Bibliotheksobjekt === 'ja')
          ) &&
          (filter2 === 'all' ||
            (filter2 === 'lepke' &&
              statusSigle && !statusSigle.indexOf('Lepke 1934')) ||
            (filter2 === 'union' &&
              statusSigle && !statusSigle.indexOf('Union 1934')) ||
            (filter2 === 'others' &&
              (!statusSigle || (statusSigle.indexOf('Lepke 1934') && statusSigle.indexOf('Union 1934')))))
        ) {
          if (item['cmsg_meta']) {
            title = this.getTitle(item)
            creatorSort = this.getSortByCreator(item)
            if (item.meta.Bibliotheksobjekt && item.meta.Bibliotheksobjekt === 'ja') {
              if (!creatorSort) {
                creatorSort = 'ohne Autorenangabe'
                author = creatorSort
              } else {
                author = this.getCreator(item)
              }
              if (infos.authors[creatorSort]) {
                infos.authors[creatorSort].titles.push({ id: item.id, title: title })
              } else {
                infos.authors[creatorSort] = { name: author, titles: [{ id: item.id, title: title }] }
                infos.sortedAuthors.push(creatorSort)
              }
            } else {
              if (creatorSort) {
                creator = this.getCreator(item)
                if (infos.creators[creatorSort]) {
                  infos.creators[creatorSort].titles.push({ id: item.id, title: title })
                } else {
                  infos.creators[creatorSort] = { name: creator, titles: [{ id: item.id, title: title }] }
                  infos.sortedNames.push(creatorSort)
                }
                infos.titles.push({ id: item.id, title: title, creator: creator })
              } else {
                infos.titles.push({ id: item.id, title: title, creator: '' })
              }
            }
          }
        }
      })
      infos.sortedNames.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
      infos.sortedAuthors.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
      infos.titles.sort((a, b) => {
        a = a.title.match(/[A-Za-z0-9]+.+/)[0].toLowerCase()
        b = b.title.match(/[A-Za-z0-9]+.+/)[0].toLowerCase()
        return a > b ? 1 : b > a ? -1 : 0
      })
      return infos
    },
    listInfoTitles: function () {
      return this.listInfo.titles
    },
    listInfoCreators: function () {
      return this.listInfo.creators
    },
    listInfoSortedNames: function () {
      return this.listInfo.sortedNames
    },
    listInfoAuthors: function () {
      return this.listInfo.authors
    },
    listInfoSortedAuthors: function () {
      return this.listInfo.sortedAuthors
    },
    imgCaption: function () {
      if (
        this.siCarousel !== null &&
        this.sharedObject &&
        this.sharedObject.imageIds &&
        this.sharedObject.imageIds[this.siCarousel] &&
        this.sharedObject.linked_objects
      ) {
        const img = this.sharedObject.linked_objects.find(e => e.id === this.sharedObject.imageIds[this.siCarousel])
        if (img && img.meta['Bildlegende']) {
          return img.meta['Bildlegende']
        }
      }
      return ''
    },
    imgCopyright: function () {
      if (
        this.siCarousel !== null &&
        this.sharedObject &&
        this.sharedObject.imageIds &&
        this.sharedObject.imageIds[this.siCarousel] &&
        this.sharedObject.linked_objects
      ) {
        const img = this.sharedObject.linked_objects.find(e => e.id === this.sharedObject.imageIds[this.siCarousel])
        if (img && img.meta['Bildrechte-Angabe']) {
          return img.meta['Bildrechte-Angabe']
        }
      }
      return ''
    },
    permLink () {
      return `MARI (Freie Universität Berlin) https://mari-portal.de/object/${this.$route.params.oid}`
    }
  }
}
</script>

<style lang="scss">
.database>.container {
  padding: 0 0 0 12px;

  .main_layout_db:last-child {
    // margin-top: 16px;

    .accent {
      // #6928ff
      background-color: #ccc !important;
      border-color: #ccc !important;
    }

    .v-carousel {
      .v-image__image--cover {
        background-size: contain !important;
        background-color: #222;
      }

      .v-responsive__content {
        cursor: pointer;
      }
    }
  }

  .xselected_object {
    padding: 0 4px !important;

    .selected-object-card {
      max-height: 100vh;
      overflow: hidden;
      overflow-y: scroll;
    }
  }

  .theme--light.v-tabs__bar {
    background-color: transparent;
  }
}

.search {
  .v-expansion-panel {
    box-shadow: none;

    &__container {
      border-bottom: thin solid rgba(0, 0, 0, 0.42) !important;
    }

    &__header {
      padding: 0;
    }

    &__body {
      padding-bottom: 16px;
    }
  }

  .v-list__tile {
    padding: 0;

    .v-list__tile--link {
      height: auto;
      padding: 0.25rem 1.125rem;
    }

    .v-list__tile__title {
      height: auto;
      line-height: 1.25;
    }
  }

  .col-inner {
    padding-left: 1.5rem;

    @media (max-width: 599px) {
      padding-left: 0.5rem;
    }
  }

  .search__extended {
    display: flex;

    label {
      top: -3px;
    }

    .v-input--selection-controls {
      margin-top: 0;
      padding-top: 0;
    }

    .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
      margin-bottom: 0;
    }

    .theme--light.v-label {
      // color: #000;
      color: rgba(0, 0, 0, 0.87);
      font-size: 0.85rem;
    }

    .accent--text {
      color: #3366ff !important;
    }

  }
}

.extended-search-btn {
  cursor: pointer;
  margin: -5px 0 20px;
}

.filter {
  .col-inner {
    margin-top: 0;
    padding-top: 0;
    padding-left: 1.5rem;

    @media (max-width: 599px) {
      padding-left: 0.5rem;
    }

    .v-select {
      margin-top: 0;
      padding-top: 0;
    }
  }
}

.object-list {
  .v-card__title {
    h3 {
      margin-bottom: 0;
    }
  }
}

.img_meta {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0 0.5rem 0.5rem 0;
  color: #fff;
  text-align: right;
}

.no_img {
  background-color: #666;
  color: #fff;
  width: 100%;
  padding: 1rem;
  text-align: center;
}

.s__cat {
  font-size: 0.8rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.s__value {
  margin-bottom: 1rem;
}

.selection_main {
  padding: 16px;
  background-color: #fff;
  margin-bottom: 0.5rem;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);

  &.error {
    background-color: #f44336;
    color: #fff;
    margin-bottom: 0;
  }

  .s__author {
    font-weight: bold;
    font-size: 1.2rem;
  }

  .s__error {
    font-weight: bold;
    font-size: 1.2rem;
  }

  .s__title {
    font-style: italic;
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
  }

  .s__tech {
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }
}

.application .v-content .linked_object_list_header,
.application .v-content .transactions_list_header {
  padding: 8px 16px;
  margin-bottom: 0;
  background-color: #666;
  color: #fff;
}

.application .v-content .transactions_list_wrapper {
  width: 100%;
}

.linked_object_list_loader {
  text-align: center;
  padding: 1rem 0;
  ;
}

.main_o_list {
  .expansion-panel {
    box-shadow: none;
  }
}

// .fsi {
//   font-style: italic;
// }

.dbox {
  padding: 0.75rem 24px;
}

.jumbotron__image {
  max-height: 100%;
  min-width: auto;
}

.carousel {
  background-color: #666;

  .jumbotron {
    cursor: pointer;
  }
}

.linked,
.application .v-content .linked {
  color: #6c07ff;
  text-decoration: none;
}

.display-block {
  display: block;
}

.list_small_item {
  // font-size: 0.9rem;
  font-size: 0.85rem;
}

.sm_bdmark_off {
  border-left: 1px solid transparent;
}

.sm_bdmark_on {
  border-left: 2px solid #6928ff;
}

.nos_source {
  margin-bottom: 1rem;
}

.v-list__tile__content .artist_list_work_title {
  font-size: 1rem;
  padding-left: 0.5rem;
}

.search_btn_col {
  text-align: right;
}

.search_btn {
  border: 0 !important;
  margin-top: 0.9rem;

  .v-btn__content {
    &:before {
      background: none !important;
    }
  }
}

.search_hint {
  font-size: 0.8rem;
}

#filter_select1 .input-group__selections__comma {
  padding-right: 0;
}

.list_thn {
  float: left;
  margin-right: 0.5rem;
  width: 128px;
  height: auto;
  padding: 0.75rem 24px;
}

.v-list__tile__title,
.v-list__tile__sub-title {
  white-space: normal;
}

.main_layout_db {
  align-items: flex-start;
}

.v-expansion-panel.sub_expansion {
  box-shadow: none;
}

.sub_expansion {
  border-bottom: 1px solid #eee;

  .expansion-panel__header,
  .v-expansion-panel__header {
    padding: 2px 0 2px 0;
  }
}

.sm_lh_mb {
  line-height: 1.25;
  margin-bottom: 0.5rem;
}

.application .v-content .linked_object_list_header.header_top {
  margin-top: 0;
}

.transaction_table table.table thead td:not(:nth-child(1)),
.transaction_table table.table tbody td:not(:nth-child(1)),
.transaction_table table.table thead th:not(:nth-child(1)),
.transaction_table table.table tbody th:not(:nth-child(1)),
.transaction_table table.table thead td:first-child,
.transaction_table table.table tbody td:first-child,
.transaction_table table.table thead th:first-child,
.transaction_table table.table tbody th:first-child {
  padding: .5rem;
}

.context-transaction {
  background: rgba(0, 0, 0, 0);
}

.citation-hint {
  margin-top: 1em;
  font-size: 13px;
}

.tabs {
  &__bar {
    background: transparent !important;
  }

  &__container {
    height: auto;
  }

  &__slider-wrapper {
    display: none;
  }

  &__div {
    width: 50%;
  }

  &__item {
    padding: 10px 0;
    justify-content: start;
    background: rgba(255, 255, 255, .5);

    &--active {
      background: #fff;
    }
  }

  &__items {
    background: #fff;
  }

  &__content {
    padding-top: 13px;
  }

  .v-card {
    box-shadow: none;
    background: transparent;

    &__title {
      padding: 16px 24px;
    }
  }
}

.shared-object-loader-container {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent !important;
}

div.transactions,
div.linked_metas {
  padding: 0 !important;
}

div.linked_metas {
  margin-top: 0.5rem;
}

.application .v-content h2.transactions_list_header {
  margin-top: 0;
}

.theme--light.v-sheet.nbg {
  background-color: transparent !important;
}

// #selected_object {
// scroll-margin-top: 32px;
// scroll-margin-top: 16px;
// }

.selected_object {
  background-color: #fff;
  margin-bottom: 0.5rem;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}

.metadata_from_sources {
  margin-top: 8px;

  > .v-expansion-panel__container > .v-expansion-panel__header {
    background-color: #666;
    color: white;
    padding-top: 8px;
    padding-bottom: 8px;
    min-height: auto;
    > .v-expansion-panel__header__icon > .v-icon {
      color: white !important;
    }
  }

  .v-expansion-panel__header,
  .px_sm {
    padding-left: 16px;
    padding-right: 16px;

    .sub_expansion {
      .v-expansion-panel__header {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}

// .v-window-item {
//   display: block !important;
// }
</style>



// WEBPACK FOOTER //
// src/components/pages/DBNew.vue